import style from './style';
import { trackEvent } from '../../utils/common';
import { LINK_TYPE_EVENTID_MAP } from '../../constant';
const { rootViewStyle, containerViewStyle, titleTextStyle, imgStyle, iconBlockStyle, lineStyle, waitTextViewStyle, linkBtnBoxStyle, twoLinkBtnStyle, singleLinkBtnStyle, wrapStyle, wxBtnStyle, wxTagStyle } = style;
import { stopBubble } from '../../utils/common';
const getDomTree = function () {
    const { waitTime } = this.pullFailDeepLinks[0] || {};
    const vDom = {
        domKey: 'rootView',
        tag: 'div',
        props: { class: 'launch-app-wait-view' },
        style: rootViewStyle,
        events: { click: () => this.viewInstance.removeUI('rootView') },
        children: [
            {
                domKey: 'containerView',
                tag: 'div',
                style: containerViewStyle,
                children: [
                    {
                        domKey: 'titleText',
                        tag: 'div',
                        text: '温馨提示',
                        style: titleTextStyle,
                    },
                    {
                        domKey: 'iconImg',
                        tag: 'img',
                        props: { src: 'https://ut-static.udache.com/webx/ut/PyKSaY5Qhtp25CyqnYP2y.png' },
                        style: imgStyle,
                    },
                    {
                        domKey: 'iconBlock',
                        tag: 'div',
                        style: iconBlockStyle,
                    },
                    {
                        domKey: 'line',
                        tag: 'div',
                        style: lineStyle,
                    },
                    {
                        domKey: 'waitTextView',
                        tag: 'div',
                        style: waitTextViewStyle,
                        children: [
                            {
                                domKey: 'descText',
                                tag: 'span',
                                text: `${this.pullDescription}`,
                                style: { textAlign: 'left' }
                            },
                            {
                                domKey: 'waitText',
                                tag: 'spn',
                                text: `请稍后...  (${waitTime}/${waitTime}s)`
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return vDom;
};
const getButtonBoxDom = function (isTwo) {
    const finalLinkBtnBoxStyle = { ...linkBtnBoxStyle };
    if (isTwo)
        finalLinkBtnBoxStyle.justifyContent = 'space-between';
    return {
        domKey: 'linkBtnBox',
        tag: 'div',
        style: finalLinkBtnBoxStyle,
        children: []
    };
};
const getWxLaunchDom = function (link) {
    const vDom = {
        domKey: 'wrap',
        tag: 'div',
        props: { class: 'wx-launch-wrap' },
        style: wrapStyle,
        children: [
            {
                domKey: 'wxTag',
                tag: 'wx-open-launch-app',
                props: { appid: 'wx7e8eef23216bade2', extinfo: link },
                style: wxTagStyle,
                children: [
                    {
                        domKey: 'script',
                        tag: 'script',
                        props: { type: 'text/wxtag-template' },
                        children: [
                            {
                                domKey: 'wxBtn',
                                tag: 'div',
                                props: { class: 'wx-launch-click-btn' },
                                style: wxBtnStyle,
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return vDom;
};
const updateDomTree = function () {
    this.viewInstance.updateNode('waitTextView', { text: this.pullFailMsg, style: { width: '570rpx' } });
    const isTwo = this.pullFailDeepLinks.length === 2;
    const linkBtnBox = getButtonBoxDom(isTwo);
    const children = [];
    this.pullFailDeepLinks.forEach((linkObj, index) => {
        const { buttonText, linkType, link, cmd, extraParam } = linkObj;
        const supportWeixinTag = this.isSupportWeixinTag(linkObj);
        const childrenItem = {
            domKey: `linkBtn${index + 1}`,
            tag: 'div',
            text: buttonText,
            props: { class: 'launch-app-btn' },
            style: isTwo ? twoLinkBtnStyle : singleLinkBtnStyle,
            children: [],
            events: {
                'click': (e) => {
                    stopBubble(e);
                    const eventId = LINK_TYPE_EVENTID_MAP[linkType];
                    if (supportWeixinTag) {
                        eventId && trackEvent(eventId);
                        return;
                    }
                    this.isClickInvokeApp = true;
                    // 如果点击口令拉端按钮，关闭该弹窗
                    if (linkType === 6) {
                        this.clearTimer();
                        this.pageHideTimer();
                        this.viewInstance.removeUI('rootView');
                    }
                    const trackParams = linkType === 4 ? { cmd, cmd_id: extraParam?.cmdId } : {};
                    eventId && trackEvent(eventId, trackParams);
                    this.handleLaunch(linkObj);
                }
            }
        };
        if (supportWeixinTag) {
            const wxLaunchDom = getWxLaunchDom(link);
            childrenItem.children.push(wxLaunchDom);
        }
        children.push(childrenItem);
    });
    linkBtnBox.children = children;
    this.viewInstance.createUI(linkBtnBox, this.viewInstance.containerView);
};
export { getDomTree, getButtonBoxDom, getWxLaunchDom, updateDomTree };
